import { ReactComponent as SVG } from "@/assets/icons/material/more-horizontal.svg";

const MoreHorizontalIcon = SVG;
export default MoreHorizontalIcon;
